import {Report, REPORT_TYPE} from '../../../models';
import {DESTINATION} from './constants';

export const isReport = (report: Report): boolean => {
  return report?.type === REPORT_TYPE.REPORT;
}

export const destinationIsChecked = (defaultDestinations: string[], option: string): boolean => {
  return defaultDestinations.indexOf(option) >= 0;
}

const SUPPORTED = [DESTINATION.EMAIL, DESTINATION.SLACK];

export const getSupportedDestinations = (destinations: string[]) => {

  return destinations.filter((destination: string) => SUPPORTED.includes(destination as any));
}
